// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 707) return "static/js/CategoryDetails.b4b2b853af2ce161f205.chunk.js";
	if (chunkId === 597) return "static/js/BingoGames.c6a17061e5cf761ee961.chunk.js";
	if (chunkId === 237) return "static/js/GameDetails.1d67106891cf8794fb0e.chunk.js";
	if (chunkId === 112) return "static/js/GameDetailsContent.03e98c358352b36bdab6.chunk.js";
	if (chunkId === 455) return "static/js/SearchCategory.6b24cac189663ec3ef28.chunk.js";
	if (chunkId === 94) return "static/js/SearchMoreResults.a432c2d857c40f035f82.chunk.js";
	if (chunkId === 86) return "static/js/SimplifiedHeader.51cdfb29507dab3bea43.chunk.js";
	if (chunkId === 660) return "static/js/SearchHeader.3a47e95343530db50ee0.chunk.js";
	if (chunkId === 265) return "static/js/SearchHistory.6310aaa486f6050d497f.chunk.js";
	if (chunkId === 606) return "static/js/ErrorPage.c0d40374774894ccc70a.chunk.js";
	if (chunkId === 32) return "static/js/GameModal.59eb789d5eafa45f439f.chunk.js";
	if (chunkId === 700) return "static/js/Copy.ced0d6a3577e8db68f1b.chunk.js";
	if (chunkId === 990) return "static/js/FloatingIcon.384f9a0f59dc6da0e8ab.chunk.js";
	if (chunkId === 620) return "static/js/ErrorContainer.a191e0058b6c66d79dc4.chunk.js";
	if (chunkId === 347) return "static/js/CookieBanner.78da7fdc6acc85d36a12.chunk.js";
	if (chunkId === 430) return "static/js/Menu.a22508585ec557c1b6fc.chunk.js";
	if (chunkId === 578) return "static/js/SearchDesktopWrapper.910867fc3a92c534c80d.chunk.js";
	if (chunkId === 896) return "static/js/SearchWrapper.93b7296bcac5c18acd6e.chunk.js";
	if (chunkId === 499) return "static/js/Download.3d29d21b414ad61b6177.chunk.js";
	if (chunkId === 410) return "static/js/SearchSuggestions.596b3ebe289a3651506f.chunk.js";
	if (chunkId === 356) return "static/js/Steps.e2883ceb05d4d23181c3.chunk.js";
	if (chunkId === 496) return "static/js/BannerStandalone.48a103575b44378fc0ee.chunk.js";
	if (chunkId === 207) return "static/js/VideoModal.c1da0cc6b3650f7ddf51.chunk.js";
	if (chunkId === 29) return "static/js/ProvidersFilter.fe5d26130e2555bcebf8.chunk.js";
	if (chunkId === 401) return "static/js/IdlePopup.86f359dc5137c7936c77.chunk.js";
	if (chunkId === 899) return "static/js/GameBanner.d0c28d1ba6064bf7cdf4.chunk.js";
	if (chunkId === 843) return "static/js/GameDual.b024a3a48ddd0bb9b8b3.chunk.js";
	if (chunkId === 349) return "static/js/GameList.3e39515fd9b8b8b826b9.chunk.js";
	if (chunkId === 827) return "static/js/Grid.b150bb8f392013893546.chunk.js";
	if (chunkId === 160) return "static/js/ExtendedGrid.d96137d87098c1bda804.chunk.js";
	if (chunkId === 659) return "static/js/WidgetGrid.a6c506afb45d18596917.chunk.js";
	// return url for filenames based on template
	return undefined;
};